import Layout from "../../hocs/Layout";
import { connect } from "react-redux";
import { Navigate, Link } from "react-router-dom";
import { reset } from "../../redux/actions/payment";
import { useEffect } from "react";

const ThankYou = ({ isAuthenticated, reset }) => {
  useEffect(() => {
    reset();
  }, [reset]);

  if (!isAuthenticated) return <Navigate to="/" />;

  return (
    <Layout>
      <div className="bg-gray-50 min-h-screen flex items-center justify-center">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg px-6 py-8 sm:px-10 sm:py-12 text-center">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold text-indigo-600 sm:text-5xl">
              ¡Gracias por tu compra!
            </h1>
            <p className="mt-4 text-lg text-gray-600">
              Esperamos que hayas disfrutado de tu experiencia en{" "}
              <span className="font-bold text-gray-900">NineRogues</span>. Si
              necesitas algo más, ¡estamos aquí para ayudarte!
            </p>
          </div>

          <div className="mt-8 flex justify-center gap-4">
            <Link
              to="/shop"
              className="px-6 py-3 bg-indigo-600 text-white rounded-lg font-medium text-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Seguir Comprando
            </Link>
            <Link
              to="/dashboard/payments"
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium text-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
            >
              Ver Mis Pagos
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps, { reset })(ThankYou);
